<template>
  <div class="padding_top_40">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
    </svg>
    <h4 class="success">Your appointment has been booked.</h4>

    <div class="text-center padding__top__15">
      <a href="http://vitusvet.com/download-the-free-app/" target="_blank" class="btn btn-lg  btn__primary  btn-lg" style="font-size:18px;">
        Download the app &nbsp;
      </a>
    </div>
    <h4 class="text-center">For support: Call us at (844) 848-8783</h4>
    <h4 class="text-center weight700 vitus-style">Powered by VitusVet</h4>
    <div class="text-center">
      <img class="text-center" src="https://my.vitusvet.com/assets/appImages/header-logo.png" alt="VitusVet Logo">
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "ConfirmationItem",
  created() {
    if (vv.boot_data && vv.boot_data.redirectUrl) {
      window.top.location = vv.boot_data.redirectUrl + this.practiceDetails.PartnerSystemId;
      return;
    }
    this.$store.dispatch('SetPageNumber', 7);
  },
  computed: {
    ...mapGetters({
      clientPracticeDetails: 'clientPracticeDetails',
      selectedPractice: 'selectedPractice'
    }),
    practiceDetails: function (params) {
      if (this.selectedPractice != null) {
        return this.selectedPractice;
      }
      return this.clientPracticeDetails;
    }
  },
  mounted() {
    this.$store.dispatch('ResetStore');
    if (typeof ga != 'undefined' && ga && vv.boot_data && vv.boot_data.google_analytics != "") {
      ga('send', 'pageview', { 'page': '/thank-you' });
      ga('send', {
        hitType: 'event',
        eventCategory: 'book-appointment',
        eventAction: 'Confirmed',
        eventLabel: 'VitusVet',
        eventValue: '90'
      });
    }
    if (typeof gtag != 'undefined' && gtag) {
      fireVitusVetGoogleTagTrackingEvent();
    }

    if (typeof fbq != 'undefined' && fbq) {
      fireVitusVetFackbookTrackingEvent();
    }
  }
}
</script>

<style lang="scss" scoped>
.vitus-style {
  color: #f5903a;
}

svg {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}
h4 {
  text-align: center;
}
h4.success {
  color: #73af55;
}

@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Confirmation.vue